import React from 'react';
import { connect, useSelector } from 'react-redux';
import { getVariantsModel, isProductSet } from 'features/product-info/ducks/selectors';
import type { CommonlyExcludedHTMLAttributeNames, HTMLAttributes } from 'types/utils';
import { Dispatch } from 'redux';
import { VARIANT_ITEM_CLICK } from 'common/components/product-variants/ducks/actions';
import { Variant } from './components/multi-axis-dropdown/components/variants-drawer-content/variant-axis/utils/types';
import { ColorCarousel, MultiAxisDropdown, SingleAxisDropdown } from './components';
import { AxisPoint } from './types';
import { calculateHideAxis } from './utils';
import { ReviewsGroupType, REVIEWS_GROUP_SET } from 'features/reviews';
import { GROUP_OF_VARIANTS } from 'common/constants';

type PdpVariantsProps = {
  onVariantClick: (ap: AxisPoint) => void;
  setReviewsGroup: (arg: ReviewsGroupType) => void;
} & Omit<HTMLAttributes, CommonlyExcludedHTMLAttributeNames>;

const Variants: React.FC<PdpVariantsProps> = ({ onVariantClick, setReviewsGroup }) => {
  const variantsModelContainer = useSelector(getVariantsModel);
  const isSet = useSelector(isProductSet);
  const { variantsModel, activePoint } = variantsModelContainer ?? {};
  const isHideAxis = calculateHideAxis(variantsModel);

  const handleOnClick = (ap: AxisPoint) => {
    onVariantClick(ap);
    return setReviewsGroup(GROUP_OF_VARIANTS);
  };

  if (!isHideAxis) {
    if (variantsModel && variantsModel.length === 1) {
      return variantsModel[0].asImageThumb ? (
        <ColorCarousel
          variantsModel={variantsModel}
          activePoint={activePoint}
          onVariantClick={handleOnClick}
        />
      ) : (
        <SingleAxisDropdown
          isProductSet={isSet}
          variantsModel={variantsModel}
          activePoint={activePoint}
          onVariantClick={handleOnClick}
        />
      );
    }

    if (variantsModel && variantsModel.length > 1) {
      return (
        <MultiAxisDropdown isProductSet={isSet} variantsModel={variantsModel} activePoint={activePoint} />
      );
    }
  }

  return null;
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
  onVariantClick: (payload: Variant) => dispatch(VARIANT_ITEM_CLICK(payload)),
  setReviewsGroup: (payload: ReviewsGroupType) => dispatch(REVIEWS_GROUP_SET(payload)),
});

export const PdpVariants = connect(null, mapDispatchToProps)(Variants);
